import {NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NbButtonModule, NbFormFieldModule, NbIconModule, NbInputModule} from '@nebular/theme';
import {FormlyModule} from '@ngx-formly/core';
import {BaseFieldType} from 'compob2b-libs';
import {TuiInputDate, TuiInputDateTimeDirective} from '@taiga-ui/kit'
import {takeUntil, tap} from 'rxjs/operators'
import {TuiDay, TuiTime} from '@taiga-ui/cdk'
import {TuiTextfield} from '@taiga-ui/core'

@Component({
  imports: [
    FormlyModule,
    NbInputModule,
    ReactiveFormsModule,
    NgIf,
    TuiInputDate,
    NbButtonModule,
    NbIconModule,
    FormsModule,
    NbFormFieldModule,
    TuiTextfield,
    TuiInputDateTimeDirective
  ],
  templateUrl: './datepicker-time.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatepickerTimeComponent extends BaseFieldType implements OnInit {
  _value;

  ngOnInit() {
    this.formControl
      .valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        tap(_ => {
          if (this.formControl.value instanceof Date) {
            this.formControl.patchValue(this.compoApiService.convertDateTime(this.formControl.value));
          }
          else {
            let date = this.getCurrentDate()
            this._value = date ? [new TuiDay(date.getFullYear(), date.getMonth(), date.getDate()), new TuiTime(date.getHours(), date.getSeconds())] : null;
          }
          this.cdr.detectChanges()
        })
      ).subscribe();
  }

  getCurrentDate(): Date {
    if (!this.formControl.value) {
      return null;
    }

    let date: Date;
    if (this.formControl.value instanceof Date) {
      date = this.formControl.value;
    }
    else {
      date = new Date(this.formControl.value);
    }

    return new Date(this.compoApiService.convertDateTime(date));
  }

  get value() {
    return this._value;
  }

  set value(value) {
    if (value) {
      let date: Date;

      if (this.getCurrentDate()) {
        // Сохраняем время при смене даты, чтобы ISO за счет смены зоны не менял день
        date = this.getCurrentDate();

        date.setFullYear(value[0].year, value[0].month, value[0].day);
        date.setHours(value[1].hours, value[1].minutes);
      }
      else {
        date = value[0].toUtcNativeDate();
        const d = new Date();
        date.setHours(d.getHours(), d.getMinutes());
      }

      this.formControl.patchValue(date);
    }
    else {
      this.formControl.patchValue(null);
    }
  }
}
